import { render } from "./Hamburger.vue?vue&type=template&id=6ba1b507&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"

import "./Hamburger.vue?vue&type=style&index=0&id=6ba1b507&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba1b507"]])

export default __exports__